'use client';
import type { HuddleClient } from '@huddle01/web-core';
import { createGenericContext } from './utils/createGenericContext.tsx';
import packageJson from '../package.json';

interface Props {
  children: React.ReactNode;
  client: HuddleClient;
}

export interface HuddleContextType {
  huddleClient: HuddleClient;
  version: string;
}

const [useHuddle01, HuddleContextProvider] =
  createGenericContext<HuddleContextType>();

const HuddleProvider = ({ children, client }: Props) => {
  client.socket.__platform = `react@${packageJson.version}`;
  return (
    <HuddleContextProvider
      value={{ huddleClient: client, version: packageJson.version }}
    >
      {children}
    </HuddleContextProvider>
  );
};

export { HuddleProvider, useHuddle01 };
